import { useRef } from 'react';
import { useMotion } from '@/hooks/useEditorialMotion';
import BookButton from '@/pages/home/components/BookButton';

interface Props { title: string; text: string; }

export default function BookingCta({ title, text }: Props) {
  const ref = useRef<HTMLElement>(null);
  useMotion(ref);
  return (
    <section ref={ref} className="bg-background-100 border-t border-background-300 py-16 md:py-24">
      <div data-group className="max-w-[1320px] mx-auto px-5 md:px-12 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-x-6 gap-y-8 items-end">
        <div data-m="left-lg" className="lg:col-span-7">
          <h2 className="font-heading font-semibold tracking-[-0.02em] leading-[1.05] text-[34px] md:text-[48px] text-foreground-950">{title}</h2>
          <p className="mt-5 text-[16px] leading-relaxed text-foreground-700 max-w-lg">{text}</p>
        </div>
        <div data-m="btn" data-at="0.3" className="lg:col-span-5 lg:justify-self-end flex flex-col gap-3 lg:items-end">
          <BookButton />
        </div>
      </div>
    </section>
  );
}